<template>
  <div class="register-container" style="background: #F4F4F4">
    <div class="content-container" style="margin-top:160px;height:675px;overflow: hidden;
      box-shadow: 0px 20px 50px 0px rgba(0, 0, 0, 0.08);border-radius: 10px;">
      <div style="float:left;width: 306px;">
        <img src="@/assets/user_images/bg.jpeg" alt="" width="306">
      </div>
      <div style="float:right;padding:40px 40px 0px 0px;background: #fff;width: 894px;height:675px;">
        <div style="color:#13c2c2;font-size: 14px;text-align:right;cursor: pointer;" @click="backWeb">返回官网</div>
        <div style="width: 336px;margin:0 auto;margin-top:100px;">
          <div style="font-size:22px;color:rgba(0,0,0,0.85);font-weight: 700;margin-bottom:8px">登录</div>
          <div style="color:rgba(0,0,0,0.65)">没有账号？去<span style="color:#13c2c2;cursor: pointer;"
              @click="goRegister">注册</span></div>
          <el-form :model="submitData" ref="submitData" class="demo-ruleForm" :rules="rules" @submit.native.prevent
            style="margin-top:40px;">
            <el-form-item label="" prop="email">
              <el-input v-model="submitData.email" autocomplete="off" placeholder="请输入邮箱">
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="pwd">
              <el-input type="password" v-model="submitData.pwd" autocomplete="off" placeholder="请输入密码">
              </el-input>
            </el-form-item>
            <!-- <el-form-item label="">
              <el-checkbox v-model="checked" style="font-size: 14px">我已阅读并接受</el-checkbox><span
                style="color:#13c2c2;font-size:14px;cursor: pointer;" @click="seeAgreement">《用户协议》</span>
            </el-form-item> -->
            <el-form-item label="">
              <el-button type="primary" style="width:100%;height:40px!important" @click="login('submitData')"
                :disabled="isClick">登录
              </el-button>
            </el-form-item>
          </el-form>
        </div>

      </div>
    </div>
    <div style="margin-top:40px;color:rgba(255,255,255,0.65);font-size:12px;text-align: center">
      小豚科技版权所有
    </div>
  </div>
</template>

<script>
  import { validUsername } from '@/utils/validate'
  import jq from "jquery"
  import md5 from 'js-md5'
  import { validatePassword, validateTelphone, validateQq } from "@/api/validate"
  import { login, checkEmail, } from "@/api/register"
  import Setting from '@/settings.js'
  import { getAuthList } from '@/api/dataTrans'
  var { webDomain, locatDomain, dicDomain, appId } = Setting
  import {
    setStroage,
    getStroage,
    getToken,
    setToken,
    removeToken,
    removeStorage
  } from '@/utils/auth' // get token from
  export default {
    name: 'Login',
    data() {
      return {
        submitData: {
          email: null,
          pwd: null
        },
        isClick: true,
        emailValidte: 0,
        pwdValidte: 0,
        rules: {
          email: [{
            required: true,
            validator: this.validateStrEmail,
            trigger: 'blur'
          }],
          pwd: [{
            required: true,
            validator: validatePassword,
            trigger: 'blur'
          }]
        },
      }
    },
    watch: {
      submitData: {
        handler(newValue, oldValue) {

          if (newValue.email && newValue.pwd) {
            this.isClick = false
          } else {
            this.isClick = true
          }
        },
        deep: true
      }
    },
    mounted() {
      removeStorage('token')
      removeStorage('userStatus')
      removeStorage('reason')
    },
    methods: {
      // 邮箱校验
      validateStrEmail(rule, value, callback) {
        var re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
        if (value == '' || value == null || value == undefined) {
          callback(new Error('邮箱不能为空'))
        } else if (value.length < 6 || value.length > 32) {
          callback(new Error('请输入6-32位的邮箱'))
        } else if (!re.exec(value)) {
          callback(new Error('邮箱格式不正确'))
        } else {
          // 唯一性校验
          checkEmail({
            email: this.submitData.email
          }).then(res => {
            if (res && res.code == 0) {
              if (res.data.result) {
                this.emailValidte = 1

                callback()
              } else {
                callback(new Error('该邮箱未注册，请先注册'))
              }
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      // 再次确认密码校验
      validateConfirmPwd(rule, value, callback) {
        if (value == '' || value == null || value == undefined) {
          callback(new Error('请再次确认密码'))
        } else if (value != this.submitData.pwd) {
          callback(new Error('两次输入的密码不一致'))
        } else {
          this.pwdValidte = 1
          callback()
        }
      },
      backWeb() {
        window.open(webDomain);
      },
      seeAgreement() {
        window.open(locatDomain + '/#/agreement')

      },
      goRegister() {
        this.$router.push({ path: '/register', query: { step: 1 ,method:1} })
      },
      // 获取菜单权限列表

      // 登录
      login(formName) {
        const _this = this
        this.$refs[formName].validate((valid) => {
          if (valid) {

            var params = {}
            params.email = this.submitData.email
            params.pwd = md5(this.submitData.pwd)
            login(params).then(res => {
              if (res && res.code == 0) {
                var status = res.data.reviewStatus
                setStroage('userStatus', res.data.reviewStatus)
                setStroage('token', res.data.token)
                setStroage('reason', res.data.reviewRemark)
                if (res.data.msg ) {
                  this.$message.error(res.data.msg)
                } else {
                  if (status == 1) {
                    this.$router.push('/home')
                    //  window.location.href=locatDomain+'/home'
                  } else if (status == 0) {
                    this.$message.error("账户已禁用")
                  } else {
                    if (status == 3 || status == 4) {
                      this.$router.push({ path: '/register', query: { step: 3 } })
                    } else {
                      this.$router.push({ path: '/register', query: { step: status } })
                    }
                  }
                }

              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  /* 修复input 背景不协调 和光标变色 */
  /* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

  $bg:#283443;
  $light_gray:#fff;
  $cursor: #fff;

  @supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
    .login-container .el-input input {
      color: $cursor;
    }
  }
</style>

<style lang="scss" scoped>
  $bg:#2d3a4b;
  $dark_gray:#889aa4;
  $light_gray:#eee;
  $success: #13c2c2;
  $stepHeight: 32px;

  .step-box {
    height: $stepHeight;
    // width: 60%;
    width: 728px;
    margin: 0px auto;
    overflow: hidden;

    // background: pink;
    .step-item {
      float: left;
      width: 295px;
      height: $stepHeight;

      div {
        display: inline-block;
        float: left;
      }

      .setp-line {
        border-bottom: 1px solid #e9e9e9;
        height: 16px;
        width: 150px;

      }

      .title {
        padding: 0px 8px;
        color: rgba($color: #000000, $alpha: 0.45);
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        line-height: $stepHeight;
      }

      .setp-num {
        height: $stepHeight;
        width: $stepHeight;
        text-align: center;
        // background: rgba($color: #000000, $alpha: 0.15);
        line-height: $stepHeight;
        font-size: 23px;
        border-radius: 100%;
        position: relative;
        color: rgb(255, 255, 255);
        // .setp-line-in {
        //   position: relative;
        //   background: #ffffff;
        //   color: rgba($color: #000000, $alpha: 0.15);
        //   height: 57px;
        //   width: 58px;
        //   left: 1px;
        //   top: 2px;
        //   border-radius: 50%;
        // }
      }

      // .setp-num-active {
      //   background: $success;
      // }
    }

    .last-item {
      width: 136px;
    }
  }

  .register-container {
    min-height: 100%;
    width: 100%;
    overflow: hidden;
    background: #F4F4F4;

    .login-form {
      position: relative;
      width: 520px;
      max-width: 100%;
      padding: 160px 35px 0;
      margin: 0 auto;
      overflow: hidden;
    }

    .tips {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;

      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }

    .svg-container {
      padding: 6px 5px 6px 15px;
      color: $dark_gray;
      vertical-align: middle;
      width: 30px;
      display: inline-block;
    }

    .title-container {
      position: relative;

      .title {
        font-size: 26px;
        color: $light_gray;
        margin: 0px auto 40px auto;
        text-align: center;
        font-weight: bold;
      }
    }

    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
    }
  }

  .loginContent {

    background: #FFFFFF;
    padding-bottom: 80px;
    border-radius: 0px 0px 10px 10px;
  }

  .theme {
    height: 60px;
    background: #1C2B36;
    text-align: center;
    color: #13c2c2;
    font-size: 22px;
    border-radius: 10px 10px 0px 0px;
    line-height: 60px;
  }

  .register {
    background-color: #fff;
    border-radius: 0px 0px 10px 10px;
    padding: 60px 147px 80px 147px;
  }

  ul,
  li {
    list-style: none;
    margin: 0px;
    padding: 0px;
  }

  .registerForm {
    width: 362px;
    margin: 0 auto;
    height: 400px;
  }

  /deep/.el-input__inner {
    height: 40px;
    line-height: 40px;
  }
</style>
